import React from 'react';
import { Slider } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import colors from '../../styles/colors';
import scorecolors from '../../styles/scoreColors';
import clsx from 'clsx';

const styles = makeStyles((theme) => ({
  container: {
    position: 'relative',
  },
  label: {
    fontSize: 14,
    position: 'absolute',
    left: -16,
    bottom: -20,
  },
  labelRight: {
    left: 'auto',
    right: -16,
  },
}));

const SliderWithStyles = withStyles({
  root: {
    color: colors.disabledGray,
    height: 3,
    padding: '13px 0',
  },
  thumb: {
    height: 40,
    width: 40,
    backgroundColor: '#fff',
    marginTop: -20,
    marginLeft: -20,
    boxShadow: 'rgba(0,0,0,0.5) 0 2px 2px',
    '&:focus, &:hover, &$active': {
      boxShadow: '#ccc 0 2px 3px 1px',
    },
    '& .value': {
      fontSize: 12,
    },

    '&.thumb-1': {
      backgroundColor: scorecolors.score10,
    },
    '&.thumb-0': {
      backgroundColor: scorecolors.score0,
    },
  },
  active: {},
  track: {
    height: 3,
  },
  rail: {
    color: colors.disabledGray,
    opacity: 1,
    height: 3,
  },
})(Slider);

const ThumbComponent = (props) => {
  return (
    <span {...props} className={clsx(props.className, `thumb-${props['data-index']}`)}>
      <span className="value">{props['aria-valuenow']}</span>
    </span>
  );
};

export const ColorSlider = (props) => {
  const classes = styles();

  return (
    <div className={classes.container}>
      <SliderWithStyles {...props} ThumbComponent={ThumbComponent} />
      <div className={classes.label}>Low</div>
      <div className={clsx(classes.label, classes.labelRight)}>High</div>
    </div>
  );
};
